<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="pond_id" :name="lodash.upperFirst($t('jala_cycles.pond'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_cycles.pond')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <jala-pond-select-ajax
            name="pond_id"
            v-model.number="model.pond_id"
            :disabled="!!model.id"
        ></jala-pond-select-ajax>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="started_at" :name="lodash.upperFirst($t('jala_cycles.started_at'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_cycles.started_at')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
          :disabled="useReferenceAt"
      >
        <date-picker
            name="date"
            type="date"
            format="DD MMMM YYYY"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.started_at"
            :disabled="useReferenceAt"
        >
        </date-picker>
      </b-form-group>
    </validation-provider>
    <b-form-group
        class="row mb-3"
        label-cols-md="2"
    >
      <b-checkbox v-model="useReferenceAt">{{ lodash.upperFirst($t('jala_cycles.use_age_at_reference')) }}</b-checkbox>
    </b-form-group>
    <b-form-group
        v-if="useReferenceAt"
        class="row mb-3"
        label-cols-md="2"
        :label="lodash.upperFirst($t('jala_cycles.age_at_reference')) + '*'"
    >
      <div class="row g-2">
        <div class="col-8">
          <validation-provider vid="referenced_at" :name="lodash.upperFirst($t('jala_cycles.referenced_at'))" rules="required" v-slot="{ validated, errors }">
            <date-picker
                name="date"
                type="date"
                format="DD MMMM YYYY"
                required
                :state="errors[0] ? false : (validated ? true : null)"
                v-model="model.referenced_at"
            >
            </date-picker>
          </validation-provider>
        </div>
        <div class="col-4">
          <validation-provider vid="age_at_reference" :name="lodash.upperFirst($t('jala_cycles.age_at_reference'))" rules="required|numeric" v-slot="{ validated, errors }">
            <numeral-input
                name="age_at_reference"
                format="0,0"
                required
                :state="errors[0] ? false : (validated ? true : null)"
                v-model.number="model.age_at_reference"
            ></numeral-input>
          </validation-provider>
        </div>
      </div>
    </b-form-group>
    <validation-provider vid="total_seed" :name="lodash.upperFirst($t('jala_cycles.total_seed'))" rules="required|numeric" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_cycles.total_seed')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="total_seed"
            format="0,0"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.total_seed"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="total_seed_type" :name="lodash.upperFirst($t('jala_cycles.total_seed_type'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_cycles.total_seed_type')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <multiselect
            name="total_seed_type"
            :value="selects.total_seed_types.find((t) => (t.id === model.total_seed_type))"
            @input="(v) => { model.total_seed_type = (v || {}).id }"
            label="label"
            :options="selects.total_seed_types"
        >
        </multiselect>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="hatchery_id" :name="lodash.upperFirst($t('jala_cycles.hatchery'))" rules="numeric" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_cycles.hatchery'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <multiselect-ajax
            name="hatchery_id"
            v-model.number="model.hatchery_id"
            url="/jala/hatcheries"
            :params="{ with: 'region' }"
        >
          <template v-slot:option="{ option }">
            <span>{{ option.name }}</span><br>
            <span><small>{{ option.region.full_name }}</small></span>
          </template>
        </multiselect-ajax>
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import JalaPondSelectAjax from '../inputs/jala-pond-select-ajax';

  export default {
    components: {
      JalaPondSelectAjax
    },
    extends: FormModel,
    data() {
      let moment = this.$moment;
      return {
        useReferenceAt: false,

        model: {
          pond_id: this.$route.query.pond_id,
          _started_at: (this.value || {}).started_at || this.$moment().format('YYYY-MM-DD'),
          total_seed: 100000,
          total_seed_type: 'actual',
          feeding_tray_count: 4,
          ...this.value,
          _referenced_at: (this.value || {}).started_at || this.$moment().format('YYYY-MM-DD'),
          get started_at() { return this._started_at; },
          set started_at(value) { this._started_at = this._referenced_at = value; },
          get referenced_at() { return this._referenced_at; },
          set referenced_at(value) { this._referenced_at = value; },
          get age_at_reference() {
            return this.started_at ? moment(this.referenced_at).startOf('day').diff(moment(this.started_at).startOf('day'), 'days') : null;
          },
          set age_at_reference(value) {
            this._started_at = moment(this.referenced_at).startOf('day').subtract(value, 'days').format('YYYY-MM-DD')
          }
        },
        selects: {
          total_seed_types: [
            { id: 'net', label: this.lodash.upperFirst(this.$t('jala_cycles.net')) },
            { id: 'gross', label: this.lodash.upperFirst(this.$t('jala_cycles.gross')) },
            { id: 'actual', label: this.lodash.upperFirst(this.$t('jala_cycles.actual')) },
          ]
        }
      }
    },
    mounted() {
      //
    }
  }
</script>
